var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    fill: "white",
    stroke: "#FFEAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6242 11.0778C16.6242 11.8314 16.8234 12.2755 17.2617 12.7874C17.5939 13.1644 17.7 13.6485 17.7 14.1736C17.7 14.6981 17.5277 15.1961 17.1824 15.6004C16.7304 16.085 16.0929 16.3944 15.4423 16.4482C14.4996 16.5286 13.5562 16.5962 12.6003 16.5962C11.6438 16.5962 10.701 16.5558 9.75825 16.4482C9.10707 16.3944 8.46961 16.085 8.0182 15.6004C7.67293 15.1961 7.5 14.6981 7.5 14.1736C7.5 13.6485 7.60674 13.1644 7.93829 12.7874C8.3903 12.2755 8.57635 11.8314 8.57635 11.0778V10.8222C8.57635 9.813 8.828 9.15311 9.3462 8.50712C10.1166 7.56502 11.3516 7 12.5735 7H12.6271C13.8752 7 15.1501 7.59221 15.9075 8.5748C16.3988 9.2075 16.6242 9.83959 16.6242 10.8222V11.0778ZM10.8445 17.8365C10.8445 17.5343 11.1218 17.396 11.3782 17.3367C11.6782 17.2733 13.5059 17.2733 13.8058 17.3367C14.0623 17.396 14.3395 17.5343 14.3395 17.8365C14.3246 18.1241 14.1559 18.3792 13.9227 18.5411C13.6204 18.7768 13.2656 18.926 12.8947 18.9798C12.6895 19.0064 12.488 19.007 12.29 18.9798C11.9185 18.926 11.5637 18.7768 11.262 18.5405C11.0282 18.3792 10.8594 18.1241 10.8445 17.8365Z",
    fill: "#FF5A62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.0a186e2c.svg";
export { ForwardRef as ReactComponent };